import {
  REQUEST_SET_CENTER_MAP,
  CLEAR_CENTER_MAP,
} from '../actions/mainMapActions'

const initialState = {
  mapCenter: null,
}

const mainMapReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SET_CENTER_MAP: {
      return Object.assign(
        {},
        state,
        {
          mapCenter: [action.lat, action.long],
        }
      )
    }
    case CLEAR_CENTER_MAP: {
      return Object.assign(
        {},
        state,
        {
          mapCenter: null,
        }
      )
    }
    default:
      return state
  }
}

export default mainMapReducer
